if (!customElements.get('lazy-autoplay-video')) {
  customElements.define(
    'lazy-autoplay-video',
    class LazyAutoplayVideo extends HTMLElement {
      connectedCallback() {
        this.video = this.querySelector('video');

        if (!this.video) return;

        if ('IntersectionObserver' in window) {
          this.observer = new IntersectionObserver(
            (entries) => {
              if (entries.some((entry) => entry.isIntersecting)) {
                this.load();
                this.observer.disconnect();
              }
            },
            { rootMargin: '300px 0px' },
          );

          this.observer.observe(this);
        } else {
          this.load();
        }
      }

      disconnectedCallback() {
        this.observer?.disconnect();
      }

      load() {
        const source = this.video?.querySelector('source[data-src]');

        if (!source) return;

        source.src = source.dataset.src;
        source.removeAttribute('data-src');
        this.video.load();
        this.video.play().catch(() => {});
      }
    },
  );
}
